import SiteMetadata from './SiteMetadata';

export default SiteMetadata;
